module.exports = __webpack_public_path__ + "img/83400.cb5f080f.jpg";